import { ChangeDetectorRef, Component, HostListener, Inject, Input, OnInit, OnDestroy, ViewChild, TemplateRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { ComponentVisibilityService } from 'src/app/services/commonService/component-visibility.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ContentService } from '../../services/content.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { environment } from 'src/environments/environment';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { RegistationUtilitiesService } from 'src/app/modules/registration/services/registation-utilities.service';
import { LinkAccountDialogComponent } from 'src/app/modules/registration/components/link-account-dialog/link-account-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, DatePipe } from '@angular/common';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { DateOfbirthComponent } from '../date-ofbirth/date-ofbirth.component';
import { ExpiryDateComponent } from '../expiry-date/expiry-date.component';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AccountService } from 'src/app/services/accountService/account.service';
import { MatTableDataSource } from '@angular/material/table';
import { CancelFlightContentService } from "src/app/modules/registration/services/cancel-flight-content.service";
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';

@Component({
  selector: 'app-add-passport-details',
  templateUrl: './add-passport-details.component.html',
  styleUrls: ['./add-passport-details.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, MatIcon, NgSelectComponent, AutoBlurSelectDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgIf, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatError, MatFormField, MatLabel, MatSuffix, MatSelect, NgFor, MatOption, MatInput, NgSwitch, NgSwitchCase, DateOfbirthComponent, ExpiryDateComponent, MatButton, MatProgressSpinner, DatePipe],
  encapsulation: ViewEncapsulation.None
})
export class AddPassportDetailsComponent implements OnInit, OnDestroy {
  bookingDataData: any = null;

  cancelFlightContent: any;
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  @Input() Nationality: string | null = null;
  @Input() Country: string | null = null;
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  addPassportForm: FormGroup;
  dataSource1 = new MatTableDataSource([]);
  dataSourcePreCheck = new MatTableDataSource<any>([]);
  documentTypes = [
    { value: 'P', viewValue: this.bookingDataData?.['b2b.book.passenger.passportno'] || this.bookingDataData?.b2b.book.passenger.passportno || 'Passport Number' },
    { value: 'I', viewValue: 'IQAMA Number' },
    { value: 'A', viewValue: this.bookingDataData?.['b2b.book.passenger.nationalid'] || this.bookingDataData?.b2b.book.passenger.nationalid || 'National ID' }
  ];

  documentTypesObj: any = {
    P: {
      heading: this.bookingDataData?.['b2b.book.passenger.passportno'] || this.bookingDataData?.b2b.book.passenger.passportno || 'Passport Number',
      input: 'Enter Passport Number'
    },
    A: {
      heading: this.bookingDataData?.['b2b.book.passenger.nationalid'] || this.bookingDataData?.b2b.book.passenger.nationalid || 'National ID',
      input: 'Enter National ID'
    },
    I: {
      heading: 'IQAMA Number',
      input: 'Enter IQAMA Number'
    },
    T: {
      heading: 'TSA Precheck / Known Traveler number',
      input: 'Enter TSA Precheck / Known Traveler number'
    },
    R: {
      heading: this.bookingDataData?.['b2b.book.passenger.redressnumber'] || this.bookingDataData?.b2b.book.passenger.redressnumber || 'Redress number',
      input: 'Enter Redress number'
    }

  };


  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }
  commonObjPipes: any = {
    countryControl: { pipe: [], all: [] },
    countryCode: { pipe: [{ id: 1, name: '' }], all: [] },
    cities: []
  }
  countriesLists: any;
  stateGroupOptions: any;
  selectedDOB0: Date | null = null;
  isDisableDateOfBirth0 = false;
  selectedValidateDate: Date | null = null;
  selectedExpiryDate: Date | null = null;
  minDate: any = { year: null, month: null, date: null };
  maxDate: any = { year: null, month: null, date: null };
  userId: string = '';
  firstName: string = '';
  originalFormValue: any;
  lastName: string = '';
  elmFirstName: string = '';
  elmLastName: string = '';
  guid: string = '';
  docName: any;
  profileName: any;
  userData: any[] = [];
  filteredDocumentTypes: any[] = [];
  bypassDate: boolean = false;
  private destroy$ = new Subject<void>();
  content: any;
  contactId: any;
  dictionaryContect: any;
  constructor(private readonly bookingContentService: BookingContentService, private readonly cancelFlightContentService: CancelFlightContentService, private fb: FormBuilder, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<AddPassportDetailsComponent>, public visibilityService: ComponentVisibilityService, private _CamApiService: CamService, private _ToastrApiService: ToastrApiService, private contentService: ContentService,
    public _ApiService: ApiService, private cdr: ChangeDetectorRef, public _CommonService: CommonService, private readonly travelerMangement: TravelerManagement, private readonly crypto: CryptoService, private readonly _RegistationUtilitiesService: RegistationUtilitiesService, private readonly dialog: MatDialog, private readonly _AccountService: AccountService, private readonly _MatDialog: MatDialog, private readonly dictionaryService: DisctionaryContent) {
    this.addPassportForm = this.fb.group({
      countryControl0: [null],
      placeOfResidence: [null],
      DocType: ['P', [Validators.required]],
      Passportno: ['',],
      DOB: [''],
      issueCountry: [null],
      passportPOI: [null],
      Validfromdate: [''],
      ExpiryDate: [''],
    });
  }
  ngOnInit(): void {
    console.log(this.data)
    this.addPassportForm.get('DocType')?.disable();

    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
      if (this.content && this.content['b2b.managetraveler.doctypelist']) {
        const docTypeList = this.content['b2b.managetraveler.doctypelist'];
        docTypeList.forEach((item: any) => {
          const key = item.Key ? item.Key.trim().toLowerCase() : '';
          const phrase = item.Phrase;

          if (key === 'passportnumber') {
            this.documentTypesObj['P'] = { heading: phrase, input: 'Enter ' + phrase };
          } else if (key === 'nationalid') {
            this.documentTypesObj['A'] = { heading: phrase, input: 'Enter ' + phrase };
          } else if (key === 'iqamanumber') {
            this.documentTypesObj['I'] = { heading: phrase, input: 'Enter ' + phrase };
          } else if (key === 'tsaprecheck') {
            this.documentTypesObj['T'] = { heading: phrase, input: 'Enter ' + phrase };
          } else if (key === 'redressnumber') {
            this.documentTypesObj['R'] = { heading: phrase, input: 'Enter ' + phrase };
          }
        });
      }
    });
    this.dictionaryService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.dictionaryContect = res;
    });
    this.userId = sessionStorage.getItem('userId') || '';
    this.guid = sessionStorage.getItem('guid') || '';
    this._ApiService.getCountriesData().then(($res) => {
      this.countriesLists = this._CommonService.groupCountriesFilter($res);
    }).catch(($err) => { });
    if (this.data.edit || this.data.data.edit) {
      this.prefillForm(this.data || this.data.data);
    }
    this.applyElmVerifiedDobLock();
      this.cancelFlightContentService.content$.subscribe((res: any) => { this.cancelFlightContent = res; });
      this.bookingContentService.content$.subscribe((res: any) => {
                  if (res) {
                      this.bookingDataData = res;
                  }
              });
  }
  async prefillForm(userData: any): Promise<void> {

    if (userData) {
      const formattedDOB = this.formatDateToCustomFormat(userData.element.docDOB);
      this.selectedDOB0 = userData.element.docDOB
      const formattedIssueDate = this.formatDateToCustomFormat(userData.element.docIssueDate);
      const formattedExpiryDate = this.formatDateToCustomFormat(userData.element.docExpiryDate);
      this.changeCountry(userData?.element?.issuingCountryCode, false)
      this.addPassportForm.patchValue({
        countryControl0: userData.element.nationality,
        placeOfResidence: userData.element.countryOfResidence,
        DocType: userData.element.docType,
        Passportno: userData.element.docNo.toUpperCase(),
        DOB: formattedDOB,
        issueCountry: userData.element.issuingCountryCode || null,
        passportPOI: userData.element.poi || null,
        Validfromdate: formattedIssueDate,
        ExpiryDate: formattedExpiryDate,
        PassportID: userData.element.id
      });
      this.applyDocTypeValidation(userData.element.docType);
      this.addPassportForm.get('city')?.setValue(userData.element.poi || '');
      this.addPassportForm.markAllAsTouched();
      this.addPassportForm.updateValueAndValidity();
      this.originalFormValue = this.addPassportForm.getRawValue();
    }
  }

  private applyElmVerifiedDobLock(): void {
    const isElmVerified = !!(this.data?.personalInfo?.isElmVerified ?? this.data?.data?.personalInfo?.isElmVerified);
    if (!isElmVerified) {
      this.addPassportForm.get('DOB')?.enable({ emitEvent: false });
      this.isDisableDateOfBirth0 = false;
      return;
    }

    const isEdit = !!(this.data?.edit || this.data?.data?.edit);
    if (!isEdit) {
      const rawDob = this.data?.personalInfo?.userDOB ?? this.data?.data?.personalInfo?.userDOB;
      const dobDate = rawDob ? new Date(rawDob) : null;
      if (dobDate && !Number.isNaN(dobDate.getTime())) {
        this.selectedDOB0 = dobDate;
        this.addPassportForm.get('DOB')?.setValue(this.formatDate(dobDate), { emitEvent: false });
      }
    }

    this.addPassportForm.get('DOB')?.disable({ emitEvent: false });
    this.isDisableDateOfBirth0 = true;
    this.isChildVisible0['isDOBCalendarVisible0'] = false;
  }
  formatDateToCustomFormat(inputDate: string): string {
    if (!inputDate) return '';
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  CloseDialog(): void {
    this.dialogRef.close();
    this.router.navigate(['/document-info-form.component.html']);
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    const isClickInside = clickedElement.closest('mat-form-field') || clickedElement.closest('app-expiry-date') || clickedElement.closest('app-date-ofbirth');
    if (!isClickInside) {
      this.isChildVisible1['isDOBCalendarVisible1'] = false;
      this.isChildVisible2['isDOBCalendarVisible2'] = false;
      this.isChildVisible0['isDOBCalendarVisible0'] = false;
      this.cdr.detectChanges();
    }
  }



  showComponent0(componentKey: string): void {
    const isElmVerified = !!(this.data?.personalInfo?.isElmVerified ?? this.data?.data?.personalInfo?.isElmVerified);
    if (isElmVerified) {
      return;
    }
    this.isChildVisible0[componentKey] = true;
    this.isChildVisible1['isDOBCalendarVisible1'] = false;
    this.isChildVisible1['isDOBCalendarVisible2'] = false;
  }
  isChildVisible0: { [key: string]: boolean } = {
    isDOBCalendarVisible0: false
  };
  pasteControlHTMLTags(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text/plain') || '';
    if (!/^[0-9\-\/]+$/.test(pastedData)) {
      event.preventDefault();
    }
  }
  onConfirm0(componentKey: string) {
    this.hideComponent0(componentKey);
  }
  hideComponent0(componentKey: string): void {
    this.isChildVisible0[componentKey] = false;
  }
  onDateSelected0(event: any): void {
    if (event.isCalenderShow === true) {
      this.selectedDOB0 = event.date;
      const formattedDate = this.formatDate(event.date);
      this.addPassportForm.get('DOB')?.setValue(formattedDate);
      this.isChildVisible0['isDOBCalendarVisible0'] = false;
    }
  }
  private formatDate(date: Date | null): string {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  passportNumberValidator(event: KeyboardEvent): void {
    const isValidKey = /^[a-zA-Z0-9]$/.test(event.key);
    if (!isValidKey) {
      event.preventDefault();
    }
  }
  showComponent1(componentKey: string): void {
    this.isChildVisible2['isDOBCalendarVisible2'] = false;
    this.isChildVisible0['isDOBCalendarVisible0'] = false;
    this.isChildVisible1[componentKey] = true;
  }
  isChildVisible1: { [key: string]: boolean } = {
    isDOBCalendarVisible1: false
  };
  blockInvalidCharactersForvaliddate(event: KeyboardEvent): void {
    const allowedKeys = /^[0-9\-\/]$/;
    if (!allowedKeys.test(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }
  onConfirm1(componentKey: string) {
    this.hideComponent1(componentKey);
  }
  hideComponent1(componentKey: string): void {
    this.isChildVisible1[componentKey] = false;
  }
  onDateSelected1(event: { date: Date | null }, key: string): void {
    // if (event.type === 'dob') {
    if (!event.date || event.date.toDateString() === new Date(0).toDateString()) {
      return;
    }
    this.selectedValidateDate = event.date;
    const formattedDate = this.formatDate(this.selectedValidateDate);
    this.addPassportForm.get('Validfromdate')?.setValue(formattedDate);
    this.isChildVisible1[key] = false;
    // }
  }
  showComponent2(componentKey: string): void {
    this.isChildVisible1['isDOBCalendarVisible1'] = false;
    this.isChildVisible0['isDOBCalendarVisible0'] = false;
    this.isChildVisible2[componentKey] = true;
  }
  isChildVisible2: { [key: string]: boolean } = {
    isDOBCalendarVisible2: false
  };
  blockInvalidCharactersForExpiryDate(event: KeyboardEvent): void {
    const allowedKeys = /^[0-9\-\/]$/;
    if (!allowedKeys.test(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }
  onConfirm2(componentKey: string) {
    this.hideComponent2(componentKey);
  }
  hideComponent2(componentKey: string): void {
    this.isChildVisible2[componentKey] = false;
  }
  onDateSelected2(event: { type: string; date: Date | null }, key: string): void {
    if (event.type === 'dob') {
      if (!event.date || event.date.toDateString() === new Date(0).toDateString()) {
        return;
      }
      this.selectedExpiryDate = event.date;
      const formattedDate = this.formatDate(this.selectedExpiryDate);
      this.addPassportForm.get('ExpiryDate')?.setValue(formattedDate);
      this.isChildVisible2[key] = false;
    }
  }
  onSave() {

    if (!this.hasFormChanged()) {
      return;
    }
    this.Loader.isSpinner = true;
    const docType = this.addPassportForm.getRawValue()?.DocType
    if (this.addPassportForm.invalid) {
      this._ToastrApiService.show('error', 'Please correct the form errors before submission.');
      this.Loader.isSpinner = false;
      return;
    }


    if (docType === 'P') {
      console.log(this.addPassportForm.value)
      this.fetchMatchProfileApi()
      return;
    }

    if (docType === 'A' || docType === 'I') {
      console.log(this.addPassportForm.value);
      this.verifyELM('nn');
      return;
    }


    if (docType === 'T' || docType === 'R') {
      this.saveDocumentTR()
      return;
    }

    // if (docType == 'P' || docType == 'A' || docType == 'I') {

    //   this.fetchMatchProfileApi()

    // } else {

    //   this.saveDocumentDetails()
    // }


  }
  hasFormChanged(): boolean {
    const currentValue = this.addPassportForm.getRawValue();

    return JSON.stringify(currentValue) !== JSON.stringify(this.originalFormValue);
  }

  get docExpiryMaxYears(): number {
    if (this.addPassportForm?.get('DocType')?.value === 'I') {
      return 1;
    }
    return 10;
  }

  verifyELM(_: any): void {
    this.firstName = this.crypto.getValueFromKey("USERFNAME") as string;
    this.lastName = this.crypto.getValueFromKey("USERLNAME") as string;
    const payload = this.buildELMPayload();

    if (!payload) return;

    this._AccountService.VerifyELMV1(payload).subscribe(
      (response) => {
        console.log(response)
        this.Loader.isSpinner = false;
        this.addPassportForm.get('Passportno')?.setErrors(null);

        const firstname = response?.data?.firstName || '';
        const lastname = response?.data?.lastName || '';
        this.elmFirstName = firstname;
        this.elmLastName = lastname;

        this.docName = firstname + ' ' + lastname;
        this.profileName = this.firstName + ' ' + this.lastName;
        if (this.docName.toUpperCase().trim() != this.profileName.toUpperCase().trim()) {
          this.dialogRef.close();
          this._MatDialog.open(this.selectionWarning, {
            data: {}
          })
        } else {
          this.fetchMatchProfileApi();
        }


      },
      (error) => {
        console.log(error)
        const control = this.addPassportForm.get('Passportno');

        control?.setErrors({
          ...control.errors,
          apiError: error?.error?.message || 'Verification failed'
        });
        control?.markAsTouched();
        this.Loader.isSpinner = false;
      },

    );
  }

  private buildELMPayload(): any | null {
    const dob = this.addPassportForm.get('DOB')?.value;
    const identity = this.addPassportForm.get('Passportno')?.value;
    const nationality = this.addPassportForm.get('countryControl0')?.value;
    const docType = this.addPassportForm.get('DocType')?.value;
    if (!dob || !identity) return null;
    const formattedDob = this.convertToISODate(dob);
    switch (docType) {
      case 'A':
        return {
          nationalID: identity,
          nationality: nationality,
          dateOfBirth: formattedDob,
        };
      case 'I':
        return {
          iqama: identity,
          dateOfBirth: formattedDob,
        };
      default:
        return null; // passport → no ELM call
    }
  }

  convertToISODate(dob: string): string {
    if (!dob) return '';
    // Split the date into day, month, and year
    const dateParts = dob.split('/');
    // If the format is correct, return the date in the desired format (YYYY-MM-DD)
    if (dateParts.length === 3) {
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];
      // Ensure the month and day are zero-padded to 2 digits
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return dob; // If the format is incorrect, return the original string
  }

  CloseWarning(status: boolean) {
    if (!status) {
      this._MatDialog.closeAll()
    }
  }
  onContinueAfterMismatch() {

    this._MatDialog.closeAll(); // popup close

    const docType = this.addPassportForm.get('DocType')?.value;
    console.log(docType)
    // 👉 A / I ke case me fetchMatching call karna hai
    if (docType === 'A' || docType === 'I') {
      this.fetchMatchProfileApi();
    }
  }

  saveDocumentTR() {
    console.log(this.data.personalInfo)
    const accountID = localStorage.getItem('additionalRefNo')
    const payload = {
      queryNo: 3,
      passportID: this.data.element.id,
      passportNationality: this.addPassportForm.get('countryControl0')?.value,
      countryOfResidence: this.addPassportForm.get('placeOfResidence')?.value,
      DocumentType: this.addPassportForm.get('DocType')?.value,
      passportNumber: this.addPassportForm.get('Passportno')?.value,
      passportDOB: this.formatDateToISOString(this.addPassportForm.get('DOB')?.value) || null,
      passportCountryCode: this.addPassportForm.get('issueCountry')?.value || null,
      passportPOI: this.addPassportForm.get('passportPOI')?.value || null,
      passportValidityStartDate: this.addPassportForm.get('Validfromdate')?.value
        ? this.formatDateToISOString(this.addPassportForm.get('Validfromdate')?.value)
        : null,

      PassportExpiryDate: this.formatDateToISOString(this.addPassportForm.get('ExpiryDate')?.value) || null,
      isPrimary: true,
      contactId: this.data.personalInfo?.contactId || null,
      accountID: accountID,
      // email: this.data.personalInfo?.email || null,
      ciamId: this.data.personalInfo?.ciamId || null,
      firstName: this.data.personalInfo?.firstName,
      lastName: this.data.personalInfo?.lastName
    };
    console.log("Payload",)
    this.userId = sessionStorage.getItem("userId") || "";
    this._CamApiService.UpdateDocumentDetails(this.userId, payload).then(response => {
      this._ToastrApiService.show('success', "Document information Insert successfully.")
      this.dialogRef.close();
      this._CommonService.formResetTrigger(); //to reset the form
      // if (this.edit) {
      //   this.travelerManagement.document_click('document_edit_save', 'Save');
      // } else {
      //   this.travelerManagement.document_click('document_save_success', 'Success');
      // }
      setTimeout(() => {
        this.Loader.isSpinner = false;
        this.Loader.isEditableClicked = true;
        //this.Addnew = false

      }, 1000)
    })
      .catch(error => {
        console.error("Error saving data", error);
        this._ToastrApiService.show('error', error.error.message)
        this._CommonService.formResetTrigger(); //to reset the form
        this.Loader.isSpinner = false;
      });
  }

  filterDocumentTypesBasedOnExistingData(): void {
    const existingDocTypes = this.userData.map(
      (doc: any) => doc.docType?.toUpperCase()
    );

    this.filteredDocumentTypes = this.documentTypes.filter(type => {

      // ❌ Remove already existing types
      if (existingDocTypes.includes(type.value)) {
        return false;
      }

      // 🔥 Simple check → if A or I exists, remove both A & I
      if (
        (existingDocTypes.includes('A') || existingDocTypes.includes('I')) &&
        (type.value === 'A' || type.value === 'I')
      ) {
        return false;
      }

      return true;
    });

  }
  formatDateToISOString(dateStr: string): string {

    if (dateStr === null) {
      return '';
    }
    const parts = dateStr.split('/').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) {
      throw new Error(`Invalid date format: ${dateStr}`);
    }
    const [day, month, year] = parts;
    if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1000) {
      throw new Error(`Invalid date values: ${dateStr}`);
    }
    const date = new Date(year, month - 1, day);
    if (isNaN(date.getTime())) {
      throw new Error(`Invalid date object created from: ${dateStr}`);
    }
    return date.toISOString();
  }
  onDocTypeChange(selectedValue: string) {
    this.elmFirstName = '';
    this.elmLastName = '';
    this.addPassportForm.reset();
    this.addPassportForm.get('DocType')?.setValue(selectedValue);
    this.applyDocTypeValidation(selectedValue);
  }

  getImageUrl(path: string): string {
    if (!path) return '';

    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');

    return `${base}/${cleanPath}`;
  }

  changeCountry(event: any, setNull: boolean = true) {
    this.commonObjPipes.cities = [];
    if (setNull) {
      this.addPassportForm.get('passportPOI')?.setValue(null);
    }
    if (!!event?.isoCode || !!event) {
      this._ApiService.GetCities(event?.isoCode ?? event, '').then(({ data: $cities }) => {
        this.commonObjPipes.cities = $cities;
      })
    }
  }
  get isPrecheckOrRedress(): boolean {

    const type = this.addPassportForm.get('DocType')?.value;
    return type === 'T' || type === 'R';
  }

  applyDocTypeValidation(docType: string) {

    const form = this.addPassportForm;

    const country = form.get('countryControl0');
    const residence = form.get('placeOfResidence');
    const passportNo = form.get('Passportno');
    const dob = form.get('DOB');
    const issueCountry = form.get('issueCountry');
    const poi = form.get('passportPOI');
    const expiry = form.get('ExpiryDate');
    const validFrom = form.get('Validfromdate');

    // 🔄 Clear all validators
    Object.keys(form.controls).forEach(key => {
      form.get(key)?.clearValidators();
      form.get(key)?.updateValueAndValidity({ emitEvent: false });
    });

    if (docType === 'T' || docType === 'R') {

      country?.setValidators([Validators.required]);
      residence?.setValidators([Validators.required]);

      passportNo?.setValidators([
        Validators.required,
        docType === 'T'
          ? Validators.pattern(/^\d{9}$/)
          : Validators.pattern(/^\d{7}$/)
      ]);

    }

    else if (docType === 'P' || docType === 'A' || docType === 'I') {

      country?.setValidators([Validators.required]);
      residence?.setValidators([Validators.required]);
      dob?.setValidators([Validators.required]);
      issueCountry?.setValidators([Validators.required]);
      poi?.setValidators([Validators.required]);
      expiry?.setValidators([Validators.required]);

      switch (docType) {

        case 'P':
          passportNo?.setValidators([
            Validators.required,
            Validators.pattern(/^[a-zA-Z0-9]{6,12}$/)
          ]);
          break;

        case 'A':
        case 'I':
          passportNo?.setValidators([
            Validators.required,
            Validators.pattern(/^\d{10}$/)
          ]);
          break;
      }
    }

    // 🔥 Update validity
    Object.keys(form.controls).forEach(key => {
      form.get(key)?.updateValueAndValidity();
    });
    this.applyElmVerifiedDobLock();
  }



  fetchMatchProfileApi() {
    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const firstName = this.crypto.getValueFromKey("USERFNAME") as string;
    const lastName = this.crypto.getValueFromKey("USERLNAME") as string;
    const contactID = this.data?.personalInfo?.contactId;
    const customerType = this.data?.personalInfo?.customerTypes;
    const formData = this.addPassportForm.getRawValue()

    const matchPayload = {
      id: formData?.Passportno,
      IDtype: this.getDocumentType(formData?.DocType),
      nationality: formData?.countryControl0,

      matchPreferences: {
        isProfileUpdate: true,
        sourceProfile: `[${customerType.join(', ')}]`,
        // sourceProfile: "[B2B]",
        contactId: contactID
      }
    };

    this._RegistationUtilitiesService
      .fetchMatching(sessionID, token, matchPayload)
      .subscribe((res: any) => {
        const hasMatch =
          Array.isArray(res?.data?.matchedContacts) &&
          res?.data?.matchedContacts.length > 0;

        if (hasMatch) {
          this.dialogRef.close();
          this.dialog.open(LinkAccountDialogComponent, {
            disableClose: true,
            data: {
              docDetail: this.data,
              matches: res.data,
              fullName: `${firstName} ${lastName}`,
              data: this.addPassportForm.getRawValue(),
              method: 'documentInfoMatch',

            },
          });
        } else {
          this.saveDocumentDetails()
        }
      }, (error: any) => {
        console.error("Error fetching matching profile", error);
        this.Loader.isSpinner = false;
        const apiDetails = error?.error?.details;
        const errorCode = apiDetails?.length > 0 ? apiDetails[0].code : null;

        if (errorCode === 'ERR-FMP-000') {
          const errorTitle = apiDetails[0].title;
          this._ToastrApiService.show('error', errorTitle);
        } else if (errorCode === 'ERR-FMP-001') {
          this.saveDocumentDetails();
        } else {
          const errorMsg = apiDetails?.length > 0 ? apiDetails[0].title : (error?.error?.message || 'fetchMatching API error');
          this._ToastrApiService.show('error', errorMsg);
        }
      });
  }
  getDocumentType(type: string): string {
    const map: any = {
      P: 'passport',
      A: 'nationalid',
      I: 'iqama'
    };

    return map[type?.toUpperCase()] || '';
  }


  saveDocumentDetails() {

    this.Loader.isSpinner = true;
    const accountID = localStorage.getItem('additionalRefNo');
    const payload = {
      QueryNo: this.data.edit ? 3 : 2,
      passportID: this.data.edit ? this.data.element.id : 0,
      passportNationality: this.addPassportForm.get('countryControl0')?.value,
      countryOfResidence: this.addPassportForm.get('placeOfResidence')?.value,
      DocumentType: this.addPassportForm.get('DocType')?.value,
      passportDOB: this._CommonService.formatDateToISOString(this.addPassportForm.get('DOB')?.value) || null,
      passportCountryCode: this.addPassportForm.get('issueCountry')?.value || null,
      passportPOI: this.addPassportForm.get('passportPOI')?.value || null,
      passportValidityStartDate: this._CommonService.formatDateToISOString(this.addPassportForm.get('Validfromdate')?.value) || null,
      PassportExpiryDate: this._CommonService.formatDateToISOString(this.addPassportForm.get('ExpiryDate')?.value) || null,
      isPrimary: true,
      passportNumber: this.addPassportForm.get('Passportno')?.value,
      secondaryContactId: this.data.personalInfo?.contactId || null,
      primaryContactId: null,
      accountID: accountID,
      ciamId: this.data.personalInfo?.ciamId || null,
      consentMerge: false,
      // email: this.data.personalInfo?.email || null,
      firstName: this.elmFirstName ? this.elmFirstName : this.data.personalInfo?.firstName,
      lastName: this.elmLastName ? this.elmLastName : this.data.personalInfo?.lastName,
      isELMVerified: this.elmFirstName ? true : false,
      elmVerificationDate: this.elmFirstName ? new Date().toISOString() : null,
      otp: null,
      checksum: null,
      type: null,
      value: null,
      otpAction: null,

    }

    this.userId = sessionStorage.getItem("userId") || "";

    this._CamApiService.UpdateDocumentDetails(this.userId, payload).then(response => {

      this._ToastrApiService.show('success', this.data.edit ? "Document information updated successfully." : "Document information saved successfully.");
      // this.travelerMangement.traveler_details('Save');
      this.travelerMangement.document_edit_savePopup('Save');
      this.travelerMangement.document_save_successPopup('Save Success', 'Success');
      setTimeout(() => {
        this.Loader.isSpinner = false;
        this.dialogRef.close();
        window.location.reload();
      }, 1000);
    }).catch(error => {
      // console.error(this.data.edit ? "Error updating data" : "Error saving data", error);
      // this._ToastrApiService.show('error', "This ID number is already registered. Please use a different one.");
      this.Loader.isSpinner = false;

      console.error("Error saving data", error);

      let msg = error?.error?.message || error?.message || "Error saving data";
      try {
        const parsedMsg = JSON.parse(error?.error?.message);
        msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
        if (parsedMsg?.target) {
          msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
        }
      } catch (e) { }

      this._ToastrApiService.show('error', msg);
    });
  }

  verifyDuplicateDocID() {
    const passportControl = this.addPassportForm.get('Passportno');
    const passportNo = passportControl?.value?.trim();

    // Passport number empty hai to API call nahi hogi
    if (!passportNo) {
      return;
    }

    const payload = {
      documentNumber: passportControl?.value,
      b2BUserId: sessionStorage.getItem('userId')
    };

    this._CamApiService.checkDuplicateDocuments(payload).then((res: any) => {
      if (res?.data === false) {
        passportControl?.setErrors({
          ...(passportControl.errors || {}),
          duplicatedoc: true
        });
      } else {
        if (passportControl?.hasError('duplicatedoc')) {
          const errors = { ...(passportControl.errors || {}) };
          delete errors['duplicatedoc'];

          passportControl.setErrors(
            Object.keys(errors).length ? errors : null
          );
        }
      }
    });
  }

  blockInvalidCharacters(event: KeyboardEvent): void {
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}', '$', '~', '@', '&', '/', '.', ','];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

    }